import { ActionIcon, createStyles, Modal } from '@mantine/core';
import React, { useState } from 'react';
import { InfoCircle } from 'tabler-icons-react';
import { useTranslation } from 'react-i18next';
import { Help } from './Help';

const useStyles = createStyles((theme) => ({
  body: {
    // fontSize: '16px',
    fontSize: theme.fontSizes.lg,
  },
  header: {
    fontSize: theme.fontSizes.xl,
  },
}));

export function HelpDialog(props: {
  description: string;
  EditingDescription: string;
}) {
  const [opened, setOpened] = useState(false);
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title={t('StatisticsHelp.Title')}
        size="lg"
        classNames={{ header: classes.header, body: classes.body }}
      >
        <Help
          description={props.description}
          EditingDescription={props.EditingDescription}
          onFinish={() => setOpened(false)}
        />
      </Modal>
      <ActionIcon
        onClick={() => setOpened(true)}
        color="yellow"
        size="sm"
        title={t('StatisticsHelp.Title')}
      >
        <InfoCircle />
      </ActionIcon>
    </>
  );
}
